const shouldAnimationReset = (element) => {
  const resetAnimation = () => {
    element.pause();
    element.currentTime = 0;
  };

  const startAnimation = () => {
    element.play();
  };

  if (element && !element.loop) {
    let elementRect = element.getBoundingClientRect();
    if (elementRect) {
      let playing = !!(
        element.currentTime > 0 &&
        !element.paused &&
        !element.ended &&
        element.readyState > 2
      );

      if (!playing) {
        const { innerHeight } = window;
        let hidden = elementRect.bottom < 0 || elementRect.top > innerHeight;
        let complete = element.currentTime / element.duration === 1;
        let rewinded = element.currentTime == 0 && element.paused;
        if (hidden && complete) {
          resetAnimation();
        } else if (!hidden && rewinded) {
          startAnimation();
        }
      }
    }
  }
};

export const bindAnimationResetScrollHandler = (element) => {
  const handleScroll = () => {
    shouldAnimationReset(element);
  };

  document.addEventListener('scroll', handleScroll);

  return handleScroll;
};
